import s from "./MPArticleError.module.css";

const MPArticleError = ({ error, codeMP }) => {
  const getErrorMessage = () => {
    if (error?.includes("не найдена") || error?.includes("404")) {
      return `Статья МУ ${codeMP || ""} не найдена`;
    }
    if (error?.includes("недоступен") || error?.includes("500")) {
      return "Сервер временно недоступен. Пожалуйста, попробуйте позже.";
    }
    if (error?.includes("Некорректный")) {
      return error;
    }
    return error || "Произошла ошибка при загрузке статьи";
  };

  return (
    <div className={s.container}>
      <div className={s.error}>
        <h2 className={s.errorTitle}>Ошибка загрузки статьи</h2>
        <p className={s.errorMessage}>{getErrorMessage()}</p>
        {codeMP && (
          <p className={s.errorCode}>
            Код МУ: <strong>{codeMP}</strong>
          </p>
        )}
      </div>
    </div>
  );
};

export default MPArticleError;
